module.exports = __webpack_public_path__ + "static/graph-year-2-2f0b6f01f4bdcd6c2509c2b389c0ce30.svg";